<template>
    <div>
    <v-tabs
      v-model="tab"
      class="elevation-2"
      :background-color="colors"
      dark
      :centered="centered"
      :grow="grow"
      :vertical="vertical"
      :right="right"
      :prev-icon="prevIcon ? 'mdi-arrow-left-bold-box-outline' : undefined"
      :next-icon="nextIcon ? 'mdi-arrow-right-bold-box-outline' : undefined"
      :icons-and-text="icons"
    >
      <v-tabs-slider></v-tabs-slider>

      

      <template  v-for="i in routes">
        <v-tab
            v-if="i.type == user.type || typeof i.type === 'undefined'"
            :href="`#tab-${i.id}`"
            @click.prevent="move(i.route)"
            :key="i.id"    
          >
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn :color="colors" dark v-on="on"><v-icon v-if="icons">{{ i.icon }}</v-icon></v-btn>
          </template>
          <span> {{i.name}} </span>
        </v-tooltip>
       </v-tab>
      </template>
       

      
    </v-tabs>
        
    </div>
</template>
<script>
export default {

    props:{

        routes:'',
        colors:''

    },

    data () {
      return {
        tab: null,
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
        icons: true,
        centered: false,
        grow: false,
        vertical: false,
        prevIcon: false,
        nextIcon: false,
        right: true,
        tabs: 3,

        items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Link 1',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
        {
          text: 'Link 2',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],


      }
    },

    computed: {
      
      user(){
        return this.$store.state.currentUser.user
      }

    },

    methods: {
        
        move(path) {

            this.$router.push({path: path}, ()=>{});

        }


    },

}
</script>